import { CampProps } from "~/interfaces"
import { RESERVATION_KINDS, reservationKind } from "~/constants/reservation_kinds"

export const stripeOptionsFn = (priceDetailsTotal: number | undefined, camp: CampProps, reservationKind?: reservationKind, setupFutureUsage?: string): any => {
  if (!priceDetailsTotal) return
  return {
    mode: "payment",
    amount: Math.round(Number(priceDetailsTotal) * 100.0),
    currency: camp.currency,
    paymentMethodTypes:
      (reservationKind && reservationKind === RESERVATION_KINDS.RECURRING && camp.recurring_payment_methods) ||
      camp.booker_payment_methods,
    appearance: {
      variables: {
        fontSizeBase: "14px", // Smaller base font size
        borderRadius: "4px", // Optional: customize border radius
      },
      rules: {
        ".Input": {
          padding: "8px 12px", // Adjust input field padding
        },
        ".Input--invalid": {
          borderColor: "#e3342f", // Optional: customize invalid state border
        },
      },
    },
    setup_future_usage: setupFutureUsage,
  }
}
